import { CLOSED_WITH_BALANCE, OPEN, SETPAY_LOANS, } from "../../../const/products";
var shouldShowAccountServiceButton = function (_a) {
    var accountSummary = _a.accountSummary;
    if (!accountSummary)
        return false;
    var conditions = accountSummary.conditions, currentBalance = accountSummary.credit.currentBalance, productType = accountSummary.product.type, _b = accountSummary.billing, customerAssistancePlan = _b.customerAssistancePlan, settlementEnrolled = _b.settlementEnrolled;
    var isOpen = conditions === null || conditions === void 0 ? void 0 : conditions.includes(OPEN);
    var isClosedWithBalance = conditions === null || conditions === void 0 ? void 0 : conditions.includes(CLOSED_WITH_BALANCE);
    var isCurrentBalanceZeroOrNegative = Number(currentBalance) <= 0;
    /*
     *Given the account is SetPay 1.0 or SetPay 2.0
     *and "accountServicingEnabled" property is False
     *https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110109681/Account+Services+Page+-+MVP+V1#:~:text=10-,SetPay%20Clients,-Setpay%20Accounts%20Are
     */
    var isSetPay = productType && SETPAY_LOANS.includes(productType);
    /*
     *Given account status = OPEN or CLOSED_WITH_BALANCE
     *and enrolled flags are "customerAssistancePlan" = TRUE or "settlementEnrolled" = TRUE
     *https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110109681/Account+Services+Page+-+MVP+V1#:~:text=Enrolled%20In%20CAP%20Accounts
     *https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110109681/Account+Services+Page+-+MVP+V1#:~:text=Enrolled%20In%20Settlement%20Accounts
     */
    var isEnrolled = customerAssistancePlan || settlementEnrolled;
    var isCAPOrSettlement = (isOpen || isClosedWithBalance) && isEnrolled;
    /*
     *Given "condition" property for account is CLOSED_WITH_BALANCE
     *and "currentBalance" property is zero or negative
     *https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110109681/Account+Services+Page+-+MVP+V1#:~:text=11-,Closed%20Accounts,-Closed%C2%A0Accounts
     */
    var isClosedWithZeroAndNegativeBalance = isClosedWithBalance && isCurrentBalanceZeroOrNegative;
    return !(isSetPay || isCAPOrSettlement || isClosedWithZeroAndNegativeBalance);
};
export default shouldShowAccountServiceButton;
//# sourceMappingURL=shouldShowAccountServiceButton.js.map